import React from 'react';
import { Linkedin, Facebook, Instagram } from 'lucide-react';

const LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/troy-oliver-13ba82425/', Icon: Linkedin, color: '#0A66C2' },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61591785357124', Icon: Facebook, color: '#1877F2' },
  { label: 'Instagram', href: 'https://www.instagram.com/oliverandsonsplumbing/', Icon: Instagram, color: '#E1306C' },
];

export default function SocialIcons() {
  return (
    <div className="flex items-center gap-3 sm:gap-4">
      {LINKS.map(({ label, href, Icon, color }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Oliver & Sons Plumbing on ${label}`}
          className="group flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-full transition-all duration-[250ms] ease-out hover:-translate-y-[3px]"
          style={{ background: '#111827', border: '1px solid #1E293B' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = color;
            e.currentTarget.style.boxShadow = `0 0 14px ${color}66, 0 4px 12px ${color}30`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#1E293B';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <Icon className="w-[18px] h-[18px] sm:w-5 sm:h-5 transition-colors duration-[250ms]" style={{ color }} />
        </a>
      ))}
    </div>
  );
}